// material-ui
import logo from '../assets/images/logo.png';


const Logo = ({ width = 170 }) => {

    return (
        <img src={logo} alt="" width={width} />
    );
};

export default Logo;
